import { createSlice} from '@reduxjs/toolkit'
import { pendingdata } from '../middleware/NotificationMiddleware';


const NotificationSlice = createSlice({
    name:'Notification',
    initialState:{
        loading:false,
        data:[],
        error:null
    },
    extraReducers:(builder)=>{
        builder
    .addCase(pendingdata.pending,(state)=>{
        state.loading = true;
        
    })
    .addCase(pendingdata.fulfilled,(state,action)=>{
       
        state.loading = false;
        // apiGet resolves to undefined on a network / CORS failure and to an
        // error response (HTML body on a 500), so only accept a real list.
        const payload = action.payload;
        if (payload?.status === 200 && Array.isArray(payload.data)) {
            state.data = payload.data;
            state.error = null;
        } else {
            state.data = [];
            state.error = payload?.data?.message || "Unable to load notifications.";
        }
    })
    
    .addCase(pendingdata.rejected,(state,action)=>{
        state.loading = false;            
        state.error=action.error.message
    })
}

})

export default NotificationSlice.reducer


